// 블로그 저자 아바타 — 저자 이름 → 로컬 헤드샷.
//
// 우선순위: 이 매핑 > 백엔드 blog_author.profile_image_url > null(호출부가 이니셜로 폴백).
//
// 왜 백엔드보다 로컬이 이기는가:
//   블로그 저자 사진으로 등록된 이미지는 아바타용으로 찍은 게 아니다. 지금 prod 에
//   올라온 김용범 변호사 사진은 인터뷰 컷이라 얼굴이 우측 상단에 치우쳐 있고 손까지
//   들어와, 원형으로 자르면 얼굴이 잘린다. 아바타는 얼굴 중심 정사각이어야 한다.
//   → 여기 큐레이션한 헤드샷을 단일 진실 소스로 두고, 매핑에 없는 저자만 백엔드
//     사진으로 폴백한다.
//
// 크롭본 출처:
//   lawyers.js 의 photo(imweb CDN, 3:4 전신)를 얼굴 중심 정사각 256px 로 크롭.
//   원본을 그대로 원형에 넣으면 가로 전체가 38px 에 눌려 얼굴이 좁쌀만 해진다.
//   → src/assets/images/lawyers/*.webp
//
// 저자가 늘면 여기 한 줄만 추가한다. 매핑에 없으면 이니셜로 떨어질 뿐 깨지지 않는다.

import kimYongbum from '../assets/images/lawyers/kim-yongbum.webp';
import choJinseok from '../assets/images/lawyers/cho-jinseok.webp';

const AVATAR_BY_NAME = {
  김용범: kimYongbum,
  조진석: choJinseok,
};

/** '김용범 변호사' → '김용범'. 저자명에 붙은 호칭을 떼고 매핑 키를 만든다. */
function bareName(name) {
  return (name || '').replace(/\s*(변호사|편집부)$/, '').trim();
}

/**
 * 저자 프로필 사진 URL. 없으면 null — 호출부가 이니셜 아바타로 폴백한다.
 * @param {{ name?: string, photo?: string|null }} [author]
 * @returns {string|null}
 */
export function getAuthorAvatar(author) {
  return AVATAR_BY_NAME[bareName(author?.name)] || author?.photo || null;
}
